export const correctiveNSType = 32
export const additiveNSType = 91